import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { IconButton, Text } from '@oneaudi/unified-web-components';
import { MonthlyRateContainer, PriceAndInfoIWrapper, PriceDivider, RateNextToInfoI, StyledPriceTextWrapper, } from './styles/FinanceRethink.styles';
import { FootnoteReference } from '../../../../components';
import { useServicesContext } from '../../../../context';
import { FinanceLayerRethink } from './FinanceLayerRethink';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { trackLayerClose } from './FinanceTracking';
import { DynamicComponent, dynamicStylingHelper } from '../../../utils';
const RATE_SUFFIX_PLACEHOLDER = '{{PRODUCT}}';
export const RateInformationRethink = ({ isPLP, vehicle, vehicleBasic, dynamicFinancingValues, staticRateConfig, }) => {
    var _a, _b, _c;
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const layerManager = useServicesContext().getAdditionalService('layer-manager');
    const [focusLayerNode, setFocusLayerNode] = useState();
    const focusLayerRef = React.useCallback((node) => {
        setFocusLayerNode(node);
    }, [setFocusLayerNode]);
    const openLayer = () => {
        layerManager.openFocusLayer(() => React.createElement("div", { ref: focusLayerRef }), {
            withFefa: true,
        }, {
            userCloseable: true,
            size: "A",
            onClose: () => {
                trackLayerClose(trackingService, 'vtp leasing layer');
            },
        });
    };
    const vehicleBasicVal = isPLP ? vehicleBasic : vehicle.basic;
    const { financing } = vehicleBasicVal;
    const rate = dynamicFinancingValues ? dynamicFinancingValues.rate : staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.price;
    const staticRateSuffix = dynamicFinancingValues !== undefined
        ? (_a = staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.suffix) === null || _a === void 0 ? void 0 : _a.replace(RATE_SUFFIX_PLACEHOLDER, dynamicFinancingValues.rateText)
        : (_b = staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.suffix) === null || _b === void 0 ? void 0 : _b.replace(RATE_SUFFIX_PLACEHOLDER, (_c = financing === null || financing === void 0 ? void 0 : financing.product) === null || _c === void 0 ? void 0 : _c.label);
    if (!rate)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(PriceDivider, { className: "vtp-price-divider" }),
        React.createElement(MonthlyRateContainer, null,
            React.createElement(PriceAndInfoIWrapper, null,
                React.createElement(RateNextToInfoI, null,
                    React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'normal' } }, staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.label),
                    React.createElement(StyledPriceTextWrapper, null,
                        React.createElement(Text, { className: "apply-alpha-style", tag: "p", variant: { type: 'copy', order: '1', style: 'normal' } },
                            rate,
                            (staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.priceFootnote) && (React.createElement(FootnoteReference, { refId: staticRateConfig === null || staticRateConfig === void 0 ? void 0 : staticRateConfig.priceFootnote }))),
                        React.createElement(DynamicComponent, { alpha: React.createElement(IconButton, { variant: "tertiary", size: dynamicStylingHelper('md', 'xs'), onClick: openLayer, icon: "info-circle", id: "info-button-price" }) })),
                    React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '3', style: 'normal' } }, staticRateSuffix)),
                React.createElement(DynamicComponent, { legacy: React.createElement(IconButton, { variant: "tertiary", size: dynamicStylingHelper('md', 'xs'), onClick: openLayer, icon: "info-circle", id: "info-button-price" }) })),
            React.createElement(React.Fragment, null, focusLayerNode &&
                ReactDOM.createPortal(React.createElement(ThemeProvider, { theme: { name: 'light' } },
                    React.createElement(FinanceLayerRethink, { isPlp: isPLP, vehicleBasic: vehicleBasicVal })), focusLayerNode)))));
};
